import { Panel } from "../Panel"
import type { TradeCounter as TradeCounterData } from "../dashboard-types"

function fmt(n: number): string {
  return n.toLocaleString()
}

export function TradeCounter({ data, demo }: { data: TradeCounterData; demo?: boolean }) {
  const congestionPct = data.ports_total > 0
    ? Math.round((data.ports_congested / data.ports_total) * 100)
    : 0

  return (
    <Panel title="Global Trade Counter" demo={demo} helpText="Aggregate global trade metrics updated in near real-time" count={data.active_vessels}>
      <div className="px-3 py-3 flex flex-col gap-3">
        {/* Hero TEU number */}
        <div className="text-center">
          <div
            className="text-3xl font-bold tabular-nums text-[color:var(--text)]"
            style={{ animation: "teu-pulse 2s ease-in-out infinite" }}
          >
            {fmt(data.daily_teu)}
          </div>
          <div className="text-[9px] uppercase tracking-widest text-[color:var(--text-dim)] mt-1">
            daily TEU
          </div>
        </div>

        {/* 3-stat grid */}
        <div className="grid grid-cols-3 gap-2 text-center">
          <div>
            <div className="text-[9px] uppercase tracking-widest text-[color:var(--text-dim)]">YTD Volume</div>
            <div className="text-base tabular-nums text-[color:var(--text)] font-semibold mt-0.5">
              {data.ytd_volume_bn_usd}<span className="text-[9px] text-[color:var(--text-dim)] ml-0.5">T USD</span>
            </div>
          </div>
          <div>
            <div className="text-[9px] uppercase tracking-widest text-[color:var(--text-dim)]">Active Vessels</div>
            <div className="text-base tabular-nums text-[color:var(--text)] font-semibold mt-0.5">
              {fmt(data.active_vessels)}
            </div>
          </div>
          <div>
            <div className="text-[9px] uppercase tracking-widest text-[color:var(--text-dim)]">In Transit</div>
            <div className="text-base tabular-nums text-[color:var(--text)] font-semibold mt-0.5">
              {fmt(data.containers_in_transit)}
            </div>
          </div>
        </div>

        {/* Congestion bar */}
        <div>
          <div className="flex items-center justify-between text-[9px] uppercase tracking-wider text-[color:var(--text-muted)]">
            <span>Ports Congested</span>
            <span className="tabular-nums">{data.ports_congested} / {data.ports_total}</span>
          </div>
          <div className="mt-1 h-1.5 rounded-full bg-zinc-800 overflow-hidden">
            <div
              className="h-full rounded-full bg-orange-500 transition-all duration-500"
              style={{ width: `${congestionPct}%` }}
            />
          </div>
        </div>
      </div>

      {/* Inline keyframe for the pulse animation */}
      <style>{`
        @keyframes teu-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }
      `}</style>
    </Panel>
  )
}
